/**
 * Advisory findings on one outcome's wording.
 *
 * @module components/studio/MimloLint
 */

import React, { useMemo } from "react";

import { Alert } from "@/components/ui";
import { lintLearningOutcome } from "@/lib/lo-lint";

export function MimloLint({
  text,
  nfqLevel,
}: {
  text: string;
  nfqLevel: number | null;
}): React.ReactElement {
  const { issues } = useMemo(
    () => lintLearningOutcome(text, { frameworkLevel: nfqLevel }),
    [text, nfqLevel],
  );
  // Mounted while empty: a live region inserted with its text is often missed.
  return (
    <div
      className={issues.length > 0 ? "mt-2 space-y-2" : undefined}
      role="status"
      aria-live="polite"
    >
      {issues.map((issue) => (
        <Alert
          key={`${issue.match}-${issue.message}`}
          tone={issue.severity === "warn" ? "warning" : "info"}
          role="none"
          className="mb-0 py-2"
        >
          {issue.message}
          {issue.suggestions.length > 0 ? ` Try: ${issue.suggestions.join(", ")}.` : ""}
        </Alert>
      ))}
    </div>
  );
}

export default MimloLint;
